import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
import ItemService from "../../../../services/construction_appCommonService";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import toast from "react-hot-toast";
import { getTodaysData } from "../../../../common/Validations";
import CustomerConstants from "../../../../common/CustomerConstants";
import { useNavigate } from "react-router-dom";
import { getQtnJobList } from "../../../../redux/feature/customer_app/customerV1Slice";
import { useDispatch, useSelector } from "react-redux";
const EntryUpdate = React.forwardRef((props, ref) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const failureCashRequest = {
    title: "Warning",
    ErrorMsg: "",
  };

  const [getFailureCashRequest] = useState(failureCashRequest);
  const [getShowFailureModal, setShowFailureCashRequest] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checkerNameOptions, setCheckerNameOptions] = useState([]);

  let documentNumber = useSelector(
    (state) => state?.customerV1?.quotation_Job?.quotation_JobNr
  );

  const [formInputs, setFormInputs] = useState({});
  useEffect(() => {
    if (!getDropdownData) return;
    setFormInputs((prev) => ({
      ...prev,
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.textCode,
      [getDropdownData?.textDesc]: getDropdownData?.textDesc,
    }));
    if (getDropdownData?.textField === "typeS") {
      setFormInputs((prev) => ({
        ...prev,
        typeS: getDropdownData?.name,
      }));
      if (getDropdownData.textField === "checkerName") {
        setFormInputs((prev) => ({
          ...prev,
          checkerName: getDropdownData.name,
          checkerNameCode: getDropdownData.textCode,
          checkerNameDesc: getDropdownData.textDesc,
        }));
      }
    }
  }, [getDropdownData]);

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const initialState = {
    transactionDate: getTodaysData() || "",
    clientName: "",
    companyName: "",
    location: "",
    validUntil: "",
    tenestinationDate: getTodaysData() || "",
    qtn_Job_RefNr: "",
    salesOfficerName: "",
    headerStatus: "",
    transactionCodeType: "",
    qtn_Job_Remarks: "",
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  //handle cancel modal
  const handleCancel = () => {
    setFormInputs((prev) => ({ ...prev, ...initialState }));
    props.onHide();
  };

  const handleInputChanges = (e) => {
    const { name, value } = e.target;
    setFormInputs((prev) => ({
      ...prev,
      [name]: value.toUpperCase(), // convert to uppercase here
    }));
  };

  // Load Checker names
  const loadCheckerNames = async () => {
    try {
      const payload = { queryName: "Get_EMPLOYEE_LIST", category: "DESIGN" };
      const response = await ItemService.generateCustomerQuery(payload);
      if (response?.status === 200) {
        const mappedData = response.data.map((emp) => ({
          checkerNameCode: emp.userId,
          name: emp.firstName,
          textDesc: emp.lastName || "",
        }));
        setCheckerNameOptions(mappedData);

        // Set default if nothing selected
        if (!formInputs.checkerNameCode && mappedData.length > 0) {
          setFormInputs((prev) => ({
            ...prev,
            checkerName: mappedData[0].name,
            checkerNameCode: mappedData[0].checkerNameCode,
            checkerNameDesc: mappedData[0].textDesc,
          }));
        }
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    loadCheckerNames();
    // eslint-disable-next-line
  }, []);
  const [queryName, setQueryName] = useState("");
  const loadFirstLevelData = async (queryName) => {
    if (!documentNumber) return;
    setLoading(true);

    let obj = {
      queryName: queryName,
      documentNumber: documentNumber,
    };

    try {
      const item = await ItemService.generateCustomerQuery(obj);

      if (item?.status === 200) {
        setFormInputs(item?.data[0]);
      } else {
        setFormInputs([]);
        console.log(`>> Error: Loading ${queryName}`);
      }
    } catch (error) {
      console.error(`>> API Error: ${queryName}`, error);
    }
    setLoading(false);
  };

  const queryMap = {
    J: "Get_JOB_DETAIL",
    QU: "Get_QUOTATION_DETAIL",
  };
  useEffect(() => {
    if (documentNumber) {
      if (documentNumber.startsWith("J")) {
        setQueryName(queryMap["J"]);
      } else if (documentNumber.startsWith("QU")) {
        setQueryName(queryMap["QU"]);
      }
    }
    // eslint-disable-next-line
  }, [documentNumber]);

  useEffect(() => {
    if (queryName && documentNumber) {
      loadFirstLevelData(queryName);
    }
    // eslint-disable-next-line
  }, [queryName, documentNumber]);

  const handleUpdate = async () => {
    let obj = {
      ...formInputs,
    };
    setDisabled(true);

    try {
      const item = await ItemService.updateQuotationOrJob(obj);
      if (item?.status === 200) {
        toast.success(item?.message || "Updated successfully", {
          duration: 2000,
          position: "top-right",
        });
        setFormInputs(
          item?.data?.length ? item.data : { ...formInputs, ...obj }
        );

        props.onHide();
        await dispatch(
          getQtnJobList({
            queryName: "Get_ENQUIRY_LIST",
            module: "",
            page: 1,
            per_page: 10,
          })
        );
        navigate(CustomerConstants.CUSTOMER_V4_HB_ENTRY_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Something went wrong. Please try again!", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      setDisabled(false);
    }
  };

  const hideFailureModal = () => {
    setShowFailureCashRequest(false);
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Project Details Update
          <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
            {documentNumber}
          </span>{" "}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/*03 */}
        {loading ? (
          <div className="flex justify-center items-center h-40">
            <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-green-500 border-solid"></div>
          </div>
        ) : (
          <div className="accordion mb-4" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                    <span className="iconLogo">BI</span>
                  </Col>

                  <Col xs={4} md={4} lg={4}>
                    <span className="headerTitle">Basic Information</span>
                    {/* <span className="subHeaderTitle">Inquire Details</span> */}
                  </Col>
                </Row>
              </h2>

              <div>
                <div className="accordion-body">
                  <Row>
                    <Col xs={12} md={12} lg={12}>
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="date"
                              // label="Date"
                              label={
                                <>
                                  <i className="bi bi-calendar-check labelIcon"></i>
                                  Date
                                </>
                              }
                              name="transactionDate"
                              id="transactionDate"
                              value={formInputs?.transactionDate}
                              onChange={handleInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Client Name"
                              label={
                                <>
                                  <i className="bi bi-person labelIcon"></i>
                                  Client Name
                                </>
                              }
                              name="clientName"
                              id="clientName"
                              value={formInputs?.clientName}
                              onChange={handleInputChanges}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Company Name"
                              label={
                                <>
                                  <i className="bi bi-building labelIcon"></i>
                                  Company Name
                                </>
                              }
                              name="companyName"
                              id="companyName"
                              value={formInputs?.companyName}
                              onChange={handleInputChanges}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Building name"
                              label={
                                <>
                                  <i className="bi bi-building-fill-down labelIcon"></i>
                                  Building name
                                </>
                              }
                              name="buildingName"
                              id="buildingName"
                              value={formInputs?.buildingName}
                              onChange={handleInputChanges}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              // label="Location"
                              label={
                                <>
                                  <i className="bi bi-geo-alt labelIcon"></i>
                                  Location
                                </>
                              }
                              placeholder=""
                              name="location"
                              id="location"
                              value={formInputs?.location}
                              onChange={handleInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Sales Officer Name"
                              label={
                                <>
                                  <i className="bi bi-person-workspace labelIcon"></i>
                                  Sales Officer Name
                                </>
                              }
                              name="salesOfficerName"
                              id="salesOfficerName"
                              value={formInputs?.salesOfficerName}
                              onChange={handleInputChanges}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Type"
                              label={
                                <>
                                  <i className="bi bi-tag labelIcon"></i>
                                  Type
                                </>
                              }
                              name="type"
                              id="type"
                              value={formInputs?.type}
                              // onChange={handleInputChanges}
                              disabled={true}
                            />
                          </Col>
                          {formInputs?.type === "Job" && (
                            <>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  // label="Job Reference Number"
                                  label={
                                    <>
                                      <i className="bi bi-card-text labelIcon"></i>
                                      Job Reference Number
                                    </>
                                  }
                                  name="jobReferenceNr"
                                  id="jobReferenceNr"
                                  value={formInputs?.jobReferenceNr}
                                  onChange={handleInputChange}
                                  disabled={true}
                                />
                              </Col>

                            </>
                          )}
                          {formInputs?.type === "Quotation" && (
                            <>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  // label="Quotation Reference Number"
                                  label={
                                    <>
                                      <i className="bi bi-card-text labelIcon"></i>
                                      Quotation Reference Number
                                    </>
                                  }
                                  name="qtnReferenceNr"
                                  id="qtnReferenceNr"
                                  value={formInputs?.qtnReferenceNr}
                                  onChange={handleInputChange}
                                  disabled={true}

                                />
                              </Col>
                            </>
                          )}
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Revision"
                              name="revision"
                              id="revision"
                              value={formInputs?.version}
                              onChange={handleInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="date"
                              // label="Estimation Date"
                              label={
                                <>
                                  <i className="bi bi-calendar-check labelIcon"></i>
                                  Estimation Date
                                </>
                              }
                              name="estimationDate"
                              id="estimationDate"
                              value={formInputs?.estimationDate}
                              onChange={handleInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Designer"
                              label={
                                <>
                                  <i className="bi bi-person-badge labelIcon"></i>
                                  Designer
                                </>
                              }

                              name="designerName"
                              id="designerName"
                              value={formInputs?.designerName}
                              onChange={handleInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              // label="CheckerName"
                              label={
                                <>
                                  <i className="bi bi-person-check labelIcon"></i>
                                  Checker Name
                                </>
                              }
                              placeholder=""
                              data={checkerNameOptions}
                              id="checkerName"
                              iconClassName="dropdownIcon"
                              name="checkerName"
                              code="checkerNameCode"
                              description="checkerNameDesc"
                              setValue={formInputs?.checkerName}
                              getvalue={setDropdownData}
                              required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              // label="Remarks"
                              label={
                                <>
                                  <i className="bi bi-chat-left-text labelIcon"></i>
                                  Remarks
                                </>
                              }
                              placeholder=""
                              name="remarks"
                              id="remarks"
                              value={formInputs?.remarks}
                              onChange={handleInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <FileUploadComponent
                              id="supportingDoc"
                              name="supportingDoc"
                              // label="Supporting Document"
                              label={
                                <>
                                  <i className="bi bi-paperclip labelIcon"></i>
                                  Supporting Document
                                </>
                              }
                              allowedTypes={[
                                "image/png",
                                "image/jpeg",
                                "application/pdf",
                              ]}
                              multiple={true} // Change to false for single file selection
                              required={true}
                              onSuccessUpload={onSuccessUploadDocumentType}
                              value={formInputs?.supportingDoc || ""}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            {(formInputs?.supportingDoc && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() =>
                                  handleViewFile(formInputs?.supportingDoc)
                                }
                              />
                            )) ||
                              "--"}
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
              {
                <Row className="my-4 ">
                  <Col
                    lg={{ span: 2, offset: 8 }}
                    className="d-flex justify-content-end mt-2"
                  >
                    <button
                      className="btnTable btn-danger"
                      onClick={handleCancel}
                      disabled={disabled}
                    >
                      Cancel
                    </button>
                  </Col>
                  <Col lg={2} className="d-flex justify-content-end mt-2">
                    <button
                      className="btnTable"
                      disabled={disabled}
                      onClick={handleUpdate}
                    >
                      Save
                    </button>
                  </Col>
                </Row>
              }
            </div>
          </div>
        )}
        <FailureModal
          show={getShowFailureModal}
          onHide={hideFailureModal}
          failureStockData={getFailureCashRequest}
        />
        <FileViewerModal
          show={getShowFileViewModal}
          onHide={handleViewFileHide}
          fileid={getFileViewData}
        />
      </Modal.Body>
    </Modal>
  );
});

export default EntryUpdate;
